module.exports = __webpack_public_path__ + "static/img/14000749.3726974d.png";